import { Injectable } from '@angular/core';
import { catchAndContinue, filterUndefined } from 'src/app/lego-utils';
import { switchMap, tap } from 'rxjs/operators';
import { SharePointService } from 'src/app/services';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';
import { handleError } from 'src/app/state/akita-error-helper';
import { CollectionState } from 'src/app/state/collection-state';
import { MouldDecisionTool } from 'src/app/models/domain';

@Injectable({ providedIn: 'root' })
export class MouldDecisionToolService {
  private readonly state = new CollectionState<MouldDecisionTool>();

  public readonly mouldDecisionTools$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(
    private readonly sharePointService: SharePointService,
    private readonly equipmentFacade: EquipmentFacadeService
  ) {}

  public loadByActiveEquipmentNumber() {
    return this.equipmentFacade.selectedEquipmentId$.pipe(
      filterUndefined(() => {
        this.state.reset();
      }),
      tap(() => {
        this.state.setLoading(true);
      }),
      switchMap((equipmentNumber) =>
        catchAndContinue(
          this.sharePointService.getMDTDocumentByEquipmentNumber(equipmentNumber),
          (error) => {
            handleError(this.state, error);
          }
        )
      ),
      tap((mdt) => {
        this.state.set(mdt);
      })
    );
  }
}
